import React from 'react'
import { Provider } from 'react-redux'
import store from '../../../(deprecated)/redux/store'

export const withRedux = (component: React.FC) => () => (
  <Provider store={store}>
    {component({})}
  </Provider>
)